type Shape<T> = { [K in keyof T]: T[K] extends string ? string : Shape<T[K]> };

/** Receivables / collections screen (`fin.rec`). */
export const recPl = {
  rec: {
    subtitle: 'Windykacja: ile klienci nam zalegają, od jak dawna i kogo ścigać w pierwszej kolejności.',
    subtitleAsOf: 'Windykacja: stan na {date}. Kogo ścigać w pierwszej kolejności.',
    kpiSection: 'Wskaźniki należności',
    kpi: {
      open: 'Należności ogółem',
      openInvoices: '{count} otwartych faktur',
      overdue: 'Przeterminowane',
      overdueShare: '{value} należności · {count} faktur',
      dso: 'DSO (dni)',
      dsoHint: 'Średni czas oczekiwania na zapłatę',
      cei: 'Skuteczność windykacji',
      ceiHint: 'CEI z ostatnich 90 dni',
      debtors: 'Dłużnicy',
      debtorsHint: 'Klienci z przeterminowaną fakturą',
      overLimit: 'Ponad limit kredytowy',
      overLimitHint: 'Rozważ wstrzymanie zamówień',
      noOverLimit: 'Nikt nie przekracza limitu',
    },
    priority: {
      title: 'Priorytet windykacji',
      old: '{count} z największych dłużników zalega ponad 60 dni — razem {amount}. Zacznij od nich.',
      limit: '{count} klientów przekroczyło limit kredytowy.',
    },
    aging: {
      title: 'Struktura wiekowa należności',
      subtitle: 'Saldo wg dni po terminie płatności.',
      notDue: 'Przed terminem',
      d0_30: '0–30 dni',
      d31_60: '31–60 dni',
      d61_90: '61–90 dni',
      d90plus: '>90 dni',
      legendNotDue: 'Przed terminem',
      legendOverdue: 'Po terminie (ciemniej = dłużej)',
      amount: 'Kwota',
      share: 'Udział w należnościach',
      invoices: 'Liczba faktur',
      invoicesN: '{count} faktur',
    },
    byRep: {
      title: 'Przeterminowane wg handlowca',
      subtitle: 'Czerwony pasek: kwota po terminie. Szary: całość otwartych należności. Kliknij, by zawęzić.',
      pctOfOpen: '{value} otwartych należności · {customers} klientów',
      invoices: '{count} faktur po terminie',
      noOwner: 'Bez opiekuna',
      filter: 'Pokaż tylko tego handlowca',
    },
    debtors: {
      title: 'Najwięksi dłużnicy',
      subtitle: '15 klientów z najwyższą kwotą po terminie, z wykorzystaniem limitu kredytowego.',
      customer: 'Klient',
      owner: 'Opiekun',
      overdue: 'Po terminie',
      days: 'Najstarsza FV',
      daysN: '{count} dni',
      invoices: 'Faktur',
      open: 'Otwarte razem',
      limit: 'Limit kredytowy',
      noLimit: 'Brak limitu',
      overLimit: 'ponad limit',
      terms: 'Termin płatn.',
      empty: 'Brak przeterminowanych należności',
    },
    trend: {
      title: 'Trend należności (12 miesięcy)',
      subtitle: 'Saldo po terminie i otwarte należności (słupki) oraz udział przeterminowanych (linia).',
      overdue: 'Po terminie',
      open: 'Otwarte razem',
      overduePct: 'Udział przeterminowanych %',
      today: 'stan na dziś',
    },
  },
};

export const recEn: Shape<typeof recPl> = {
  rec: {
    subtitle: 'Collections: how much customers owe us, for how long, and who to chase first.',
    subtitleAsOf: 'Collections: as of {date}. Who to chase first.',
    kpiSection: 'Receivables indicators',
    kpi: {
      open: 'Total receivables',
      openInvoices: '{count} open invoices',
      overdue: 'Overdue',
      overdueShare: '{value} of receivables · {count} invoices',
      dso: 'DSO (days)',
      dsoHint: 'Average wait for payment',
      cei: 'Collection effectiveness',
      ceiHint: 'CEI over the last 90 days',
      debtors: 'Debtors',
      debtorsHint: 'Customers with an overdue invoice',
      overLimit: 'Over credit limit',
      overLimitHint: 'Consider holding orders',
      noOverLimit: 'Nobody exceeds the limit',
    },
    priority: {
      title: 'Collections priority',
      old: '{count} of the biggest debtors are over 60 days late — {amount} in total. Start with them.',
      limit: '{count} customers exceeded their credit limit.',
    },
    aging: {
      title: 'Receivables ageing',
      subtitle: 'Balance by days past the payment due date.',
      notDue: 'Not yet due',
      d0_30: '0–30 days',
      d31_60: '31–60 days',
      d61_90: '61–90 days',
      d90plus: '>90 days',
      legendNotDue: 'Before due date',
      legendOverdue: 'Overdue (darker = older)',
      amount: 'Amount',
      share: 'Share of receivables',
      invoices: 'Invoices',
      invoicesN: '{count} invoices',
    },
    byRep: {
      title: 'Overdue by rep',
      subtitle: 'Red bar: overdue amount. Grey: total open receivables. Click to filter.',
      pctOfOpen: '{value} of open receivables · {customers} customers',
      invoices: '{count} overdue invoices',
      noOwner: 'No owner',
      filter: 'Show only this rep',
    },
    debtors: {
      title: 'Top debtors',
      subtitle: '15 customers with the highest overdue amount, with credit limit usage.',
      customer: 'Customer',
      owner: 'Owner',
      overdue: 'Overdue',
      days: 'Oldest invoice',
      daysN: '{count} days',
      invoices: 'Invoices',
      open: 'Total open',
      limit: 'Credit limit',
      noLimit: 'No limit',
      overLimit: 'over limit',
      terms: 'Payment terms',
      empty: 'No overdue receivables',
    },
    trend: {
      title: 'Receivables trend (12 months)',
      subtitle: 'Overdue balance and open receivables (bars) with the overdue share (line).',
      overdue: 'Overdue',
      open: 'Total open',
      overduePct: 'Overdue share %',
      today: 'as of today',
    },
  },
};
